<template>
  <a-card class="m-display-flex flex-column nowrap">
    <span slot="title">Create Other Outcome</span>
    <a-form class="margin-bottom" :form="form">
      <a-row :gutter="12">
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" class="m-page-wrapper">
          <a-form-item label="Date">
            <a-date-picker
              placeholder="Select Date"
              disabled
              :format="getDefaultDateFormat"
              v-decorator="[
                'tanggal',
                {
                  rules: [{ required: true }],
                  initialValue: initialData.create_dt,
                },
              ]"
            />
          </a-form-item>
          <!-- <a-form-item label="Jenis Anggaran">
            <a-select
                    showSearch
                    :not-found-content="null"
                    option-filter-prop="children"
                    v-decorator="[
              'jenis_anggaran',
              {
                rules: [{ required: true }],
                initialValue: initialData.jns_anggaran_id,
              },
            ]"
                    @change="handleJenisAnggaran"
            >
              <a-select-option v-for="item in getJenisAnggaran" :key="item.value">{{
                item.text
                }}</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="Cost Center">
              <a-select
                :disabled="disableCostCenter"
                showSearch
                :not-found-content="null"
                option-filter-prop="children"
                v-decorator="[
                  'cost_center',
                  {
                    rules: [{ required: true }],
                    initialValue: initialData.cost_center,
                  },
                ]"
                @change="handleCost"
              >
                <a-select-option
                  v-for="item in costCenter"
                  :key="item.value"
                  >{{ item.text }} ({{item.nama_pekerjaan ? item.nama_pekerjaan : '-'}})</a-select-option
                >
              </a-select>
          </a-form-item>

          <a-form-item label="Peruntukan">
            <a-select
              :disabled="disablePeruntukan"
              showSearch
              :not-found-content="null"
              option-filter-prop="children"
              v-decorator="[
                'peruntukan',
                {
                  rules: [{ required: true }],
                  initialValue: initialData.peruntukan,
                },
              ]"
              @change="handlePeruntukan"
            >
              <a-select-option v-for="item in peruntukan" :key="item.value">{{
                item.text
              }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item  label="Kode Anggaran">
            <a-tree-select
                    v-decorator="['kode_anggaran', {rules: [{required: true}]}]"
                    show-search
                    style="width: 100%"
                    :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                    :tree-data="anggaran.tree"
                    treeNodeFilterProp="children"
                    :filterTreeNode="filterTreeNode"
                    placeholder="Please select"
                    allow-clear
                    :disabled="anggaran.tree.length==0"
                    tree-default-expand-all
            >
                <template #suffixIcon><a-icon 
                :type="(anggaran.loadingtree ? 'loading' : 'down') " /></template>
              <span slot="title" slot-scope="item">
                <table style="width:100%">
                  <tr>
                    <td>
                      <span> {{item.texttitle}} - {{item.kode_anggaran}}</span>
                    </td>
                    <td>
                      <span style="float:right"> {{formatRupiah(parseFloat(item.rekap))}} </span>
                    </td>
                  </tr>
                </table>
              </span>
            </a-tree-select>
            </a-form-item> -->
            <a-form-item label="Transfer To">
            <a-input
              v-decorator="['transfer_to', { rules: [{ required: true }] }]"
            ></a-input>
          </a-form-item>
          <a-form-item label="Value">
            <a-input-number
              class="m-width-full"
              :formatter="
                (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              "
              :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
              v-decorator="[
                'value',
                {
                  rules: [{ required: true }, { validator: checkMaxValue }],
                },
              ]"
            ></a-input-number>
          </a-form-item>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" class="m-page-wrapper">
          <a-form-item label="Currency">
            <a-select
              showSearch
              v-decorator="[
                'currency',
                {
                  rules: [{ required: true }],
                  initialValue: mataUang.mata_uang,
                },
              ]"
              @change="handleMataUang"
            >
              <a-select-option
                v-for="item in getAllMataUang"
                :key="item.code"
                :value="item.code"
                >{{ item.code }} - {{ item.currency }}</a-select-option
              >
            </a-select>
          </a-form-item>
          <a-form-item label="Description">
            <a-textarea :rows="5"
              v-decorator="['description', { rules: [{ required: true }] }]"
            ></a-textarea>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button
          :class="btnSaveLoading ? '' : 'padding-remove'"
          :loading="btnSaveLoading"
          type="primary"
          @click="save"
          >Save</a-button
        >
      </div>
    </template>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import moment from "moment";
import GlobalMethod from "@/mixins/GlobalMethod.js";

export default {
  name: "CreateOtherOutcome",
  props: ["id", "type"],
  mixins: [CurrencyFormat, GlobalMethod],
  components: {},
  data() {
    return {
      postData: new FormData(),
      push: [],
      mataUang: {
        kurs: 1,
        estimate_value: 0,
        mata_uang: "IDR",
      },
      btnSaveLoading: false,
      costCenter:[],
      peruntukan: [],
      anggaran: {
        modalvalue: undefined,
        path:"",
        limit: 0,
        tree: [],
        treeModal:[],
        searchValue: "",
        loadingtree: false,
      },
    };
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getStandartFormatDate",
      "getDefaultDateFormat",
      "getAllMataUang",
      "getJenisAnggaran",
      "getPeruntukan",
      "getSubPeruntukan",
      "getCostCenter",
      "getAnggaran",
    ]),
    initialData() {
      return {
        create_dt: moment(),
      };
    },
    disableCostCenter:  function () {
      if(this.costCenter.length > 0){
          return false;
      }else{
          return true;
      }
    },
    disablePeruntukan:  function () {
      if (this.peruntukan.length > 0) {
              return false;
      } else {
          return true;
      }
    },
  },
  created() {
    this.$store.dispatch("FETCH_COST_CENTER");
    this.fetchMataUang();
  },
  methods: {
    moment,
    submit() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        this.postData = new FormData();
        this.postData.append("tlc", this.getAuth.username);

        this.postData.append(
          "tanggal",
          moment(values.tanggal).format(this.getStandartFormatDate)
        );
        this.postData.append("transfer_to", values.transfer_to);
        this.postData.append("value", values.value);
        this.postData.append("currency", values.currency);
        this.postData.append("description", values.description);
        // let kanggaran = values.kode_anggaran.split(";");
        // this.postData.append("anggaran_dtl_val_id", kanggaran[kanggaran.length-1]);

        this.btnSaveLoading = true;

        axios({
          method: "post",
          url: this.$serviceUrl + "other_outcome",
          processData: false,
          data: this.postData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.displayMessage("success-save");
            this.btnSaveLoading = false;
            this.$router.push({ name: "otheroutcome" });
          })
          .catch((err) => {
            let response = Object.assign({}, err.response);
            this.btnSaveLoading = false;
            this.displayMessageValue("error", response);
          });
      });
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      let extension =
        file.name.substr(file.name.lastIndexOf(".")) == ".xls" ||
        file.name.substr(file.name.lastIndexOf(".")) == ".xlsx";
      if (extension) {
        if (FileSize > 2) {
          this.displayMessage("large-file-2mb");
        } else {
          this.push = [file];
          this.form.resetFields();
          return false;
        }
      } else {
        this.displayMessage("error-formatXls");
      }
    },
    handleRemove() {
      this.push = [];
    },
    save() {
      this.form.validateFields((err) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        this.confirmMessage("confirm-save");
      });
    },
    fetchMataUang() {
      this.$store.dispatch("FETCH_ALL_MATA_UANG");
    },
    handleMataUang(kurs) {
      this.mataUang.mata_uang = kurs;
      if (kurs == "IDR") {
        this.form.kurs = 1;
      } else {
        this.form.kurs = 1;
      }
    },
    checkMaxValue(rule, value, callback) {
      if (value <= 999999999999) {
        callback();
        return;
      }
      callback("Max. value 999.999.999.999!");
    },
    handleJenisAnggaran(e){
      let filter = [];
        this.form.setFieldsValue({cost_center: null});
        this.form.setFieldsValue({peruntukan: null});
        this.form.setFieldsValue({sub_peruntukan: null});
        this.form.setFieldsValue({kode_anggaran: null});
        this.costCenter = [];
        this.peruntukan = [];
        this.subPeruntukan = [];
        this.anggaran.tree = [];
        filter = this.getCostCenter.filter(
            (obj) => obj.jns_anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
        );
      this.costCenter = filter;
    },
    
    handleCost(e) {
      this.subPeruntukan = [];
      this.anggaran.tree = [];
      this.peruntukan = [];
      this.form.setFieldsValue({sub_peruntukan: null});
      this.form.setFieldsValue({kode_anggaran: null});
      this.form.setFieldsValue({peruntukan: null});
      const peruntukan = this.getPeruntukan.filter(
        (obj) => obj.anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );
      this.peruntukan = peruntukan;
    },
    handlePeruntukan(e) {
      this.getTreeAnggaran(e);
    },
    handleCodeAnggarn(e){
    },
    filterTreeNode(input, option) {
      return (
          option.data.props.texttitle==undefined || (option.data.props.texttitle ? option.data.props.texttitle : "").toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
          (option.data.props.kode_anggaran ? option.data.props.kode_anggaran : "").toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    getTreeAnggaran(e){
      this.anggaran.loadingtree = true;
      let formvalue = this.form.getFieldsValue();
      let dataParams = {
          anggaran_id: formvalue.cost_center,
          tlc: this.getAuth.username,
          peruntukan_id: e
      }
      axios({
          method: "get",
          url: this.$serviceUrl + "other_outcome/tree_anggaran",
          params: dataParams,
          auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
          },
          headers: {
              "X-API-KEY": this.getAuth.apikey,
          },
      })
          .then((response) => {
              this.anggaran.tree = response.data.tree;
              this.anggaran.loadingtree = false
          })
          .catch((err) => {
              this.anggaran.loadingtree = false
              let responses = Object.assign({}, err.response);
              this.displayMessageValue("error", responses);
          });
    },
  },
  mounted() {
    Event.$on("confirmMessageReturn", this.submit);
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.submit);
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
};
</script>

<style>
</style>